<script lang="ts">
	import Attachments from "@components/Attachments.svelte";
	import BookMeeting from "@components/BookMeeting.svelte";
	import Photogallery from "@components/Photogallery.svelte";
	import Section from "@components/Section.svelte";
	import ServicesCards from "@components/ServicesCards.svelte";
	import CkEditorContent from "@components/common/CkEditorContent.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Media from "@components/common/Media.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import { toDateMonthYearFormat } from "@core/utils/toDateMonthYearFormat.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { BookMeetingPerson, getBookMeetingPeople } from "../data/getBookMeetingPeople.js";
	import { getServices } from "../data/getServices.js";
	import type { NewsDetailProps } from "./NewsDetailProps.js";

	const { news }: NewsDetailProps = $props();
	const { tenant } = getGlobalTemplateProps();

	const contacts = $derived(getBookMeetingPeople(tenant));
	const lightbox = news.id;
</script>

<Layout ogImage={news.primaryImage}>
	<div class="w-full lg:max-w-3xl article">
		<h1 class="mt-6 sm:mb-8 sm:mt-12">{news.title}</h1>
		{#if news.primaryImage}
			<Media
				{lightbox}
				source={news.primaryImage}
				sourcesets={{
					/* TODO podle toho jak to teda nakonec bude nastylované :) */
				}}
				class="w-full h-72 rounded-lg mt-5 object-cover mb-6"
				alt={news.title}
				height={384}
				width={1231}
			/>
		{/if}
		<p class="text-md leading-8 sm:text-lg text-fstonyx">{news.perex}</p>
		<time datetime={news.publishedAt} class="italic mb-2 mt-6 block"
			>— zveřejněno {toDateMonthYearFormat(news.publishedAt, tenant.locale)}</time
		>

		<CkEditorContent class="mb-24 mt-12" html={news.content} lightboxId={lightbox} />
	</div>
	{#if news.images.length > 0}
		<h2 class="mb-6">Fotogalerie</h2>
		<Photogallery class="full-width mb-12" images={news.images} {lightbox} />
	{/if}

	{#if news.attachments.length > 0}
		<h2 class="mb-6">Přílohy</h2>
		<Attachments class="mb-12" attachments={news.attachments} />
	{/if}

	<Section centered gridHeadline="container-6" noPadding="bot">
		{#snippet headline()}
			<Formatted text="S čím vám mimo jiné cg[[pomůžeme]]" />
		{/snippet}
	</Section>
	<ServicesCards cards={getServices(tenant)} />
	<Section noPadding="top" />
	<BookMeeting contacts={[contacts[BookMeetingPerson.Kucera], contacts[BookMeetingPerson.Svejda]]} />
</Layout>
